/**
 * An id unique on the page, for one component's life (what a `popovertarget`, a label's `for`, an `aria-*` points at).
 * Not Preact's `useId`: its ids repeat for components mounted after the first render (a selection's bar, its "⋯"
 * menu taking the page's `<main>`'s id, so its button opened nothing).
 */

import { useState } from "preact/hooks";

let made = 0;

export function useId(): string {
  const [id] = useState(() => {
    made += 1;
    return `u${made}`;
  });
  return id;
}
